import { useState } from 'react';
import { mainSiteUrl } from '@/mocks/categories';

const tabs = [
  {
    id: 'spreadsheet',
    label: 'Spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=Digital%20spreadsheet%20interface%20on%20laptop%20screen%20with%20product%20thumbnails%2C%20clean%20modern%20UI%20design%2C%20warm%20screen%20glow%2C%20workspace%20closeup&width=120&height=80&seq=tab-spread-v2&orientation=landscape',
  },
  {
    id: 'produtos',
    label: 'Produtos',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20fashion%20product%20grid%20display%2C%20sneakers%20and%20hoodies%20on%20minimalist%20shelves%2C%20retail%20display%20closeup%2C%20warm%20studio%20lighting&width=120&height=80&seq=tab-prod-v2&orientation=landscape',
  },
  {
    id: 'precos',
    label: 'Preços',
    image: 'https://readdy.ai/api/search-image?query=Price%20tags%20and%20discount%20labels%20on%20fashion%20items%2C%20sale%20concept%20closeup%2C%20warm%20retail%20photography%20with%20soft%20lighting&width=120&height=80&seq=tab-prec-v2&orientation=landscape',
  },
];

export default function AboutSection() {
  const [activeTab, setActiveTab] = useState('spreadsheet');

  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/3] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20modern%20workspace%20with%20laptop%20and%20fashion%20magazines%20displayed%20on%20wide%20wooden%20desk%20near%20sunlit%20window%20with%20flowing%20curtains%2C%20warm%20natural%20lighting%2C%20cream%20and%20sand%20aesthetic%2C%20lifestyle%20editorial%20photography%20with%20soft%20organic%20shadows%2C%20peaceful%20productive%20atmosphere&width=800&height=600&seq=about-hoobuy-v3&orientation=landscape"
                alt="O que é Hoobuy Sheet - Guia de compras"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-4 left-4 flex gap-2">
                <span className="px-3 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-foreground-800 text-xs font-medium whitespace-nowrap">
                  Guia
                </span>
                <span className="px-3 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-foreground-800 text-xs font-medium whitespace-nowrap">
                  2026
                </span>
                <span className="px-3 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-foreground-800 text-xs font-medium whitespace-nowrap">
                  Atualizado
                </span>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-light text-foreground-950 mb-6 leading-tight">
              O que é o<br />
              <span className="font-semibold">Hoobuy Sheet?</span>
            </h2>

            <div className="flex gap-3 mb-6">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeTab === tab.id
                      ? 'bg-foreground-900 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <img
                    src={tab.image}
                    alt={tab.label}
                    className="w-5 h-5 rounded object-cover"
                    loading="lazy"
                  />
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="bg-foreground-900 rounded-2xl p-6 md:p-8 relative overflow-hidden">
              <span className="absolute top-4 left-4 text-[10px] uppercase tracking-widest text-accent-400 font-semibold">
                Guia
              </span>
              <div className="mt-4">
                <h3 className="text-xl md:text-2xl font-heading font-semibold text-background-50 mb-4">
                  A Melhor Lista de Compras da China
                </h3>
                <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-4">
                  O HoobuySpreadsheet é uma lista curada e atualizada diariamente com os melhores produtos disponíveis para compra na China. Sneakers, streetwear, acessórios e artigos virais — tudo organizado para si.
                </p>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 text-sm font-medium text-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap"
                >
                  Explorar a Lista Completa
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}